import { useTheme } from '@chaser/components';
import useOnMount from './useOnMount';
import { useState } from 'react';

/**
 * Hook returns one value from the array of values based on the matching breakpoint from the theme
 * Takes the first value if the window width is below the first breakpoint, the second value
 * if the window width is above the first breakpoint, etc.
 * @param {any[]} values Array of values. Can't be changed between renders
 * @returns {any} One of the values
 */
function useResponsiveValue(values) {
  const { breakpoints } = useTheme();
  const mediaQueryLists = breakpoints.map(width => window.matchMedia(`(min-width: ${width})`));

  function getValue() {
    const index = mediaQueryLists.map(mql => mql.matches).lastIndexOf(true);
    if (index + 1 >= values.length) return values[values.length - 1];

    return values[index + 1] !== undefined ? values[index + 1] : values[0];
  }

  const [value, setValue] = useState(getValue);

  useOnMount(() => {
    const handler = () => setValue(getValue);
    mediaQueryLists.forEach(mql => mql.addListener(handler));
    return () => mediaQueryLists.forEach(mql => mql.removeListener(handler));
  }, []);

  return value;
}

export default useResponsiveValue;
